/**
 * This file is autogenerated. Do not edit manually.
 * Run `yarn generate:feature-flags` to regenerate.
 */

export enum FeatureFlag {
  ENABLE_SUBFLOW = 'enable-subflow',
  ENABLE_BFCM = 'enable-bfcm',
  COMMIT_AVATAX_TRANSACTIONS = 'commit-avatax-transactions',
  SUBFLOW_V2_BOOKS_ADDON_MVP_ENABLED = 'subflow_v2_books_addon_mvp_enabled',
  SUBFLOW_V2_ENABLE_STANDALONE_UPSELL = 'subflow_v2_enable_standalone_upsell',
  SUBFLOW_V2_BOOKS_ADDON_SUPPORTED_LANGUAGES = 'subflow_v2_books_addon_supported_languages',
  SUBFLOW_V2_ENABLE_PREVIOUS_PLAY_ADD_ONS = 'subflow_v2_enable_previous_play_add_ons',
  SUBFLOW_V2_ENABLE_4YO_SCHEDULE = 'subflow_v2_enable_4yo_schedule',
  SUBFLOW_V2_ENABLE_3YO_SCHEDULE = 'subflow_v2_enable_3yo_schedule',
  SUBFLOW_V2_IS_INTL_STORE = 'subflow_v2_is_intl_store',
  UPDATED_CHECKOUT_COPY = 'updated-checkout-copy',
  RETENTION_TEMPORARY_ENABLE_FUND_KIT = 'retention_temporary_enable-fund-kit',
  SUBSCRIPTION_BUILDER_V2 = 'subscription-builder-v2',
  SRS_TEMPORARY_DISABLE_SHOPIFY_ORDERS = 'srs_temporary_disable-shopify-orders',
  MONEY_USER_REFERRAL_CREDIT = 'money-user-referral-credit',
  MUTUALLY_EXCLUSIVE_SUB_FLOW_EXPERIMENT_PREREQ = 'mutually-exclusive-sub-flow-experiment-prereq',
  RETENTION_PERMANENT_ENABLE_EASYPOST_TRACKING = 'retention_permanent-enable-easypost-tracking',
  RETENTION_PERMANENT_ENABLE_ADDRESS_HOLDS = 'retention_permanent-enable-address-holds',
  MUTUALLY_EXCLUSIVE_HOMEPAGE_EXPERIMENT_PREREQ = 'mutually-exclusive-homepage-experiment-prereq',
  RETENTION_PERMANENT_EXPIRED_HOLDS_CRON_SCHEDULE = 'retention_permanent-expired-holds-cron-schedule',
  RETENTION_PERMANENT_REMORSE_INITIAL_FULFILLMENT_DELAY = 'retention_permanent-remorse-initial-fulfillment-delay',
  RETENTION_PERMANENT_REMORSE_RECURRING_FULFILLMENT_DELAY = 'retention_permanent-remorse-recurring-fulfillment-delay',
  RETENTION_TEMPORARY_ALLOW_UNVERIFIED_ADDRESS_FULFILLMENT = 'retention_temporary-allow-unverified-address-fulfillment',
  RETENTION_TEMPORARY_PLAY_GENIUS_2_0 = 'retention_temporary-play-genius-2-0',
  READING_SKILL_SET = 'reading-skill-set',
  RETENTION_PERMANENT_ADDRESS_VERIFICATION = 'retention_permanent-address-verification',
  RETENTION_ENABLE_SMS_MESSAGING = 'retention-enable-sms-messaging',
  RETENTION_LIFECYCLE_EMAIL_SUPPRESSION = 'retention_lifecycle-email-suppression',
  GROWTH__ENABLE_CHECKOUT_REWRITE = 'growth__enable-checkout-rewrite',
  RETENTION_ENABLE_EMAILS_AND_PUSH_NOTIFICATIONS = 'retention-enable-emails-and-push-notifications',
  GROWTH_ENABLE_WHATS_APP_WIDGET = 'growth_enable-whats-app-widget',
  GROWTH_INTERMEDIATE_STEP_BUILDER = 'growth-intermediate-step-builder',
  GROWTH_CHECKOUT_DISCOUNT_CODE_FIELD_DEFAULT_STATE = 'growth_checkout-discount-code-field-default-state',
  GROWTH_ENABLE_FORGET_SOMETHING_BANNER = 'growth-enable-forget-something-banner',
  GROWTH_ENABLED_PICK_UP_WHERE_YOU_LEFT_OFF_BANNER = 'growth-enabled-pick-up-where-you-left-off-banner',
  GROWTH_TEMPORARY_USER_REPOSITORY_CACHING = 'growth_temporary-user-repository-caching',
  MONEY_ENABLE_BFCM_2024 = 'money_enable-bfcm-2024',
  RETENTION_ENABLE_SUBSCRIPTION_V_2_PAGE = 'retention-enable-subscription-v-2-page',
  GROWTH_TEMPORARY_ENABLE_INTERMEDIATE_STEP_OBJECT = 'growth_temporary_enable-intermediate_step_object',
  RETENTION_ENABLE_EXTENSION_REACTIVATION_V_2 = 'retention_enable-extension-reactivation-v-2',
  GROWTH_ENABLE_TRUSTED_SHOP_WIDGET = 'growth_enable-trusted-shop-widget',
  GROWTH_ENABLE_CHAT_WIDGET = 'growth_enable-chat-widget',
  SAMPLE_FEATURE = 'sample-feature',
  GROWTH_SERVER_SIDE_CHECKOUT_ANALYTICS = 'growth-server-side-checkout-analytics',
  RETENTION_ENABLE_POWERED_BY_PG_LOGO = 'retention-enable-powered-by-pg-logo',
  GROWTH_CHECKOUT_AUTO_APPLY_CODE = 'growth_checkout-auto-apply-code',
  RETENTION_ENABLE_INTERMEDIATE_CART_UPSELL_PAGE = 'retention_enable-intermediate-cart-upsell-page',
  MONEY = 'money',
  MONEY_ENABLE_BFCM_2024_HOMEPAGE = 'money-enable-bfcm-2024-homepage',
  RETENTION_ENABLE_ADA = 'retention-enable-ada',
  RETENTION_ENABLE_WHATS_APP_WIDGET = 'retention-enable-whats-app-widget',
  MONEY_ENABLE_BACKORDER_MESSAGE_THE_MUSIC_SET = 'money_enable-backorder-message-the-music-set',
  GROWTH_ENABLE_DELIVERY_EXPECTATIONS = 'growth_enable-delivery-expectations',
  TRC_ACCESS = 'trc-access',
  RETENTION_ENABLE_ADA_GREETING = 'retention-enable-ada-greeting',
  GROWTH_20241211_A_A = 'growth_20241211-A-A',
  GROWTH_ENABLE_LINK_PAYMENT = 'growth_enable-link-payment',
  GROWTH_CHECKOUT_EXPERIMENT_V4_LIVE = 'growth_checkout-experiment-v4-live',
  GROWTH_CHECKOUT_EXPERIMENT_V5_LIVE = 'growth_checkout-experiment-v5-live',
  SUB_SQUAD_ADA_ENVIRONMENT = 'sub-squad-ada-environment',
  SUB_SQUAD_ENABLE_THE_READING_CLUB_LP = 'sub-squad-enable-the-reading-club-lp',
  MONEY_CONTENTFUL_DRAFT_MODE = 'money_contentful-draft-mode',
  SUB_SQUAD_ENABLE_SHOP_ALL_NAVIGATION_DROPDOWN = 'sub-squad-enable-shop-all-navigation-dropdown',
  SRS_ALLOW_0_DISCOUNT_CODE = 'srs-allow-0-discount-code',
  SUB_SQUAD_ENABLE_TABS_ON_RSS_PDP = 'sub-squad-enable-tabs-on-rss-pdp',
  MONEY_SUBCA_MVP = 'money_subca_mvp',
  MONEY_ENABLE_FULFILLABLE_LINE_ITEMS = 'money_enable-fulfillable-line-items',
  SUB_SQUAD_ENABLE_BIG_PUF = 'sub-squad-enable-big-puf',
  MONEY_INCREASE_PERCEIVED_PK_SUB_VALUE = 'money_increase-perceived-pk-sub-value',
  SUB_SQUAD_ENABLE_TARIFF = 'sub-squad-enable-tariff',
  MONEY_1576_ENABLE_SUBSCRIBE_AND_SAVE = 'money-1576_enable-subscribe-and-save',
  MONEY_1699_FLAGGED_FREE_COURSES = 'money-1699-flagged-free-courses',
  MONEY_ENABLE_SUBSCRIBE_AND_SAVE = 'money_enable-subscribe-and-save',
  SUB_SQUAD_ENABLE_BABYLIST_SHIPPING_ADJUSTMENT = 'sub-squad-enable-babylist-shipping-adjustment',
  MONEY_1796_OVERWRITE_DUPLICATE_VARIANT_ITEMS_IN_CART = 'money-1796-overwrite-duplicate-variant-items-in-cart',
  MONEY_ENABLE_INDIVIDUAL_PLAYTHINGS = 'money_enable-individual-playthings',
  SUB_SQUAD_ENABLE_CANCEL_SAVER_PROGRAM = 'sub-squad-enable-cancel-saver-program',
  MONEY_1895_PLAY_KIT_SUBSCRIBER_STATUS_UPDATE = 'MONEY-1895-play-kit-subscriber-status-update',
  SUB_SQUAD_COMPONENT_LIBRARY = 'sub-squad-component-library',
  TEMPORARY_MONEY_BATH_SET_LAUNCH = 'temporary_money-bath-set-launch',
  MONEY_1924_BFCM2025 = 'MONEY-1924-bfcm2025',
  MONEY_1927_SUB_ENGINE_SUBSCRIBER_STATUS_UPDATE = 'MONEY-1927-sub-engine-subscriber-status-update',

  MONEY_BATH_SET_PDP = 'money_bath-set-pdp',
  TEMPORARY_MONEY_LIST_SEGMENT_POC = 'temporary_money-list-segment-poc',
  MONEY_RESALE_VALUE_ON_PLK_PDP = 'money_resale-value-on-plk-pdp',
  HIDE_URL_PRODUCTS_BATH_SET_WITH_FEATURE_FLAG = 'HIDE_URL_products-bath-set-with-feature-flag',
  HIDE_URL_PRODUCTS_THE_BATH_SET = 'HIDE_URL_products-the-bath-set',
  SUB_SQUAD_ENABLE_ERC_PAUSE_STATE = 'sub-squad-enable-erc-pause-state',
  MONEY_RESALE_VALUE_ON_PLK_PDP_V2 = 'money_resale-value-on-plk-pdp-v2',
  MONEY_BFCM_MODE_2025 = 'money_bfcm-mode-2025',
  SUB_SQUAD_ENABLE_DISCOUNT_DOLLAR_SAVINGS = 'sub-squad-enable-discount-dollar-savings',
  MONEY_ENABLE_CART_NEXT_JS_MIGRATION = 'money_enable-cart-next-js-migration',
  SUB_SQUAD_CANCEL_SAVER_OPTIMIZE_2164 = 'sub-squad-cancel-saver-optimize',
  SUB_SQUAD_CANCEL_SAVER_OPTIMIZE_2165 = 'sub-squad-cancel-saver-optimize-2165',
  SUB_SQUAD_PK_YOTPO_OVERRIDE = 'sub-squad-pk-yotpo-override',
  SUB_SQUAD_NO_DOB_2187 = 'sub-squad-no-dob-2187',
  SUB_SQUAD_ERC_CTA_2146 = 'sub-squad-erc-cta-2146',
  SUB_SQUAD_NAV_REDESIGN = 'sub-squad-navigation-redesign',
  SUB_SQUAD_NAV_DYNAMIC = 'sub-squad-navigation-dynamic-categories',
}

export type FeatureFlagValues = {
  'enable-subflow': true | false;
  'enable-bfcm': true | false;
  'commit-avatax-transactions': true | false;
  subflow_v2_books_addon_mvp_enabled: true | false;
  subflow_v2_enable_standalone_upsell: true | false;
  subflow_v2_books_addon_supported_languages: true | false;
  subflow_v2_enable_previous_play_add_ons: true | false;
  subflow_v2_enable_4yo_schedule: true | false;
  subflow_v2_enable_3yo_schedule: true | false;
  subflow_v2_is_intl_store: true | false;
  'updated-checkout-copy': true | false;
  'retention_temporary_enable-fund-kit': true | false;
  'subscription-builder-v2': true | false;
  'srs_temporary_disable-shopify-orders': true | false;
  'money-user-referral-credit': true | false;
  'mutually-exclusive-sub-flow-experiment-prereq': '1' | '2';
  'retention_permanent-enable-easypost-tracking': true | false;
  'retention_permanent-enable-address-holds': true | false;
  'mutually-exclusive-homepage-experiment-prereq': '1' | '2';
  'retention_permanent-expired-holds-cron-schedule':
    | '*/10 * * * *'
    | '*/5 * * * *';
  'retention_permanent-remorse-initial-fulfillment-delay': 24 | 1 | 0 | 2;
  'retention_permanent-remorse-recurring-fulfillment-delay': 24 | 1 | 0 | 2;
  'retention_temporary-allow-unverified-address-fulfillment': true | false;
  'retention_temporary-play-genius-2-0': 'current' | 'test' | 'live';
  'reading-skill-set': true | false;
  'retention_permanent-address-verification': true | false;
  'retention-enable-sms-messaging': true | false;
  'retention_lifecycle-email-suppression': true | false;
  'growth__enable-checkout-rewrite': true | false;
  'retention-enable-emails-and-push-notifications': true | false;
  'growth_enable-whats-app-widget': true | false;
  'growth-intermediate-step-builder': true | false;
  'growth_checkout-discount-code-field-default-state': 'open' | 'closed';
  'growth-enable-forget-something-banner': true | false;
  'growth-enabled-pick-up-where-you-left-off-banner': true | false;
  'growth_temporary-user-repository-caching': true | false;
  'money_enable-bfcm-2024': true | false;
  'retention-enable-subscription-v-2-page': true | false;
  'growth_temporary_enable-intermediate_step_object': true | false;
  'retention_enable-extension-reactivation-v-2': true | false;
  'growth_enable-trusted-shop-widget': true | false;
  'growth_enable-chat-widget': true | false;
  'sample-feature': true | false;
  'growth-server-side-checkout-analytics': true | false;
  'retention-enable-powered-by-pg-logo': true | false;
  'growth_checkout-auto-apply-code': true | false;
  'retention_enable-intermediate-cart-upsell-page': true | false;
  money: true | false;
  'money-enable-bfcm-2024-homepage': true | false;
  'retention-enable-ada': true | false;
  'retention-enable-whats-app-widget': true | false;
  'money_enable-backorder-message-the-music-set': true | false;
  'growth_enable-delivery-expectations': 0 | 5;
  'trc-access': true | false;
  'retention-enable-ada-greeting': true | false;
  'growth_20241211-A-A': 'off' | 'a1' | 'a2';
  'growth_enable-link-payment': true | false;
  'growth_checkout-experiment-v4-live': true | false;
  'growth_checkout-experiment-v5-live': true | false;
  'sub-squad-ada-environment':
    | 'lovevery-nam-gr'
    | 'sandbox-lovevery-gr'
    | 'sandbox-alternative-example'
    | 'lovevery-eu-gr';
  'sub-squad-enable-the-reading-club-lp': true | false;
  'money_contentful-draft-mode': true | false;
  'sub-squad-enable-shop-all-navigation-dropdown': true | false;
  'srs-allow-0-discount-code': true | false;
  'sub-squad-enable-tabs-on-rss-pdp': true | false;
  money_subca_mvp: 'enabled' | 'disabled';
  'money_enable-fulfillable-line-items': true | false;
  'sub-squad-enable-big-puf': true | false;
  'money_increase-perceived-pk-sub-value': 'off' | 'control' | 'treatment';
  'sub-squad-enable-tariff': true | false;
  'money-1576_enable-subscribe-and-save': 'off' | 'control' | 'enabled';
  'money-1699-flagged-free-courses': unknown | unknown;
  'money_enable-subscribe-and-save': 'off' | 'control' | 'enabled';
  'sub-squad-enable-babylist-shipping-adjustment': true | false;
  'money-1796-overwrite-duplicate-variant-items-in-cart':
    | 'off'
    | 'logging'
    | 'overwrite';
  'money_enable-individual-playthings': true | false;
  'sub-squad-enable-cancel-saver-program': true | false;
  'MONEY-1895-play-kit-subscriber-status-update': 'off' | 'logging' | 'enabled';
  'sub-squad-component-library': true | false;
  'temporary_money-bath-set-launch': 'disabled' | 'presale' | 'enabled';
  'MONEY-1924-bfcm2025': 'off' | 'subscribers' | 'all';
  'MONEY-1927-sub-engine-subscriber-status-update':
    | 'off'
    | 'logging'
    | 'enabled';

  'money_bath-set-pdp': true | false;
  'temporary_money-list-segment-poc':
    | 'disabled'
    | 'playkit_subscriber_variant'
    | 'erc_subscriber_variant';
  'money_resale-value-on-plk-pdp': 'off' | 'control' | 'treatment';
  'HIDE_URL_products-bath-set-with-feature-flag': true | false;
  'HIDE_URL_products-the-bath-set': true | false;
  'sub-squad-enable-erc-pause-state': true | false;
  'money_resale-value-on-plk-pdp-v2': 'off' | 'control' | 'treatment';
  'money_bfcm-mode-2025': 'off' | 'all' | 'presale';
  'sub-squad-enable-discount-dollar-savings': true | false;
  'money_enable-cart-next-js-migration':
    | 'off'
    | 'control'
    | 'treatment-page'
    | 'treatment-drawer';
  'sub-squad-cancel-saver-optimize': 'a' | 'b';
  'sub-squad-cancel-saver-optimize-2165': 'a' | 'b';
  'sub-squad-pk-yotpo-override': true | false;
  'sub-squad-no-dob-2187': 'a' | 'b' | 'off';
  'sub-squad-erc-cta-2146': 'a' | 'b' | 'off';
  'sub-squad-navigation-redesign': true | false;
  'sub-squad-navigation-dynamic-categories': true | false;
};
